<template>
  <div id="content-container" v-if="item">
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="申请详情">
      </el-page-header>
      <el-descriptions title="" size="small" border :column="2">
        <el-descriptions-item label="申请单号">{{
          item.order_number
        }}</el-descriptions-item>
        <el-descriptions-item label="申请状态">
          <ItemStatus :status="item.status" model="apply"></ItemStatus>
        </el-descriptions-item>
        <el-descriptions-item label="申请人">{{
          item.user.name
        }}</el-descriptions-item>
        <el-descriptions-item label="申请基地/钻井">{{
          item.well.well_number || item.base.name
        }}</el-descriptions-item>
        <el-descriptions-item label="申请时间" v-if="item.status > 1">
          {{ $time(item.created_at).format('YYYY-MM-DD HH:mm') }}
        </el-descriptions-item>
        <el-descriptions-item label="申请备注">
          {{ item.remark }}
        </el-descriptions-item>
        <template v-if="item.status > 2">
          <el-descriptions-item label="审批人">
            {{ item.approver.name }}
          </el-descriptions-item>
          <el-descriptions-item label="审批时间">
            {{ $time(item.approve_time).format('YYYY-MM-DD HH:mm') }}
          </el-descriptions-item>
          <el-descriptions-item label="审批备注">
            {{ item.approve_remark || '无' }}
          </el-descriptions-item>
        </template>
      </el-descriptions>
      <p class="mt-30">
        <el-link :underline="false" v-if="canApprove">审批及物资调拨</el-link>
        <el-link :underline="false" v-else>物资明细</el-link>
      </p>
      <el-form :model="item" ref="form" label-width="0" size="small">
        <el-form-item prop="remark" class="long">
          <el-table border :data="item.items" size="mini">
            <el-table-column label="类型" width="120" align="center">
              <template slot-scope="scope">
                {{ ApplyItemCategoryMap[scope.row.category] }}
              </template>
            </el-table-column>
            <el-table-column label="名称" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.product_template.name ||
                  scope.row.item_template.name
                }}
              </template>
            </el-table-column>
            <el-table-column label="型号" prop="model_number" align="center">
            </el-table-column>
            <el-table-column label="申请数量" prop="quantity" align="center">
            </el-table-column>
            <el-table-column label="备注" prop="remark" align="center">
            </el-table-column>
            <el-table-column label="调拨物资" min-width="160">
              <template slot-scope="scope">
                <template v-if="item.status == 3">
                  <el-tag
                    size="small"
                    class="mr-5 m-b-5"
                    v-for="m in scope.row.materials"
                    :key="m.id"
                  >
                    <ProductDialog
                      :model="m"
                      v-if="[1, 3].includes(scope.row.category)"
                      >{{ m.code }}</ProductDialog
                    >
                    <ItemLink :model="m" v-else>
                      {{ m.code }}
                    </ItemLink></el-tag
                  >
                </template>
                <template v-else-if="canApprove">
                  <ProductMultipleSelect
                    v-if="scope.row.product_template_id"
                    :templateId="scope.row.product_template_id"
                    :baseId="item.approve_base_id"
                    :modelNumber="scope.row.model_number"
                    v-model="scope.row.material_ids"
                  ></ProductMultipleSelect>
                  <ItemSelect
                    v-if="scope.row.item_template_id"
                    :baseId="item.approve_base_id"
                    :templateId="scope.row.item_template_id"
                    :modelNumber="scope.row.model_number"
                    v-model="scope.row.material_ids"
                  ></ItemSelect>
                </template>
                <span v-else>无</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item prop="approve_remark" v-if="canApprove">
          <el-input
            v-model="item.approve_remark"
            placeholder="审批备注"
            type="textarea"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="" v-if="canApprove">
          <el-popconfirm
            title="确认审批不通过吗？"
            @confirm="handleApprove(false)"
          >
            <el-button size="small" type="danger" slot="reference"
              >审批不通过</el-button
            >
          </el-popconfirm>
          <el-popconfirm
            title="确认审批通过吗？"
            @confirm="handleApprove(true)"
          >
            <el-button
              size="small"
              type="primary"
              class="ml-10"
              slot="reference"
              >审批通过</el-button
            >
          </el-popconfirm>
          <div class="text-danger ml-5">
            操作提示：审批通过前请选择好需要调拨的物资编号，审批不通过则不需要选择；审批通过后调拨的物资会自动出库，状态变更为待申请基地接收。
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { applyDetail, applyApprove } from '@/service/getData'
import { ApplyItemCategoryMap } from '@/config/global'
import ItemSelect from '../../components/select/item_multiple_select.vue'

export default {
  components: {
    ItemSelect,
  },
  data() {
    return {
      ApplyItemCategoryMap,
      item: null,
    }
  },
  computed: {
    canApprove() {
      return (
        this.item &&
        this.item.status == 2 &&
        this.hasAuth('applyApprove') &&
        this.item.approve_base_id == this.$store.state.userInfo.base_id
      )
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await applyDetail({
        id: this.$route.params.id,
        list_name: this.$route.meta.module || '',
      })
      if (res.status != 0) return
      this.item = res.data
    },

    async handleApprove(isPass = false) {
      let res = await applyApprove({
        items: this.item.items,
        id: this.item.id,
        pass: isPass,
        remark: this.item.approve_remark,
      })
      if (res.status != 0) return
      this.$message.success('操作成功')
      this.item = res.data
    },
  },
}
</script>